<template>
	<v-layout class="mt-3 mb-5 fast-select-1-page py-5" row wrap fill-height align-center justify-center>
		<v-flex xs12 sm10 md8 lg6 xl4>
			<v-card>
				<v-card-text class="pa-4">
					<h3 class="headline mb-1">Výběr akce</h3>

					<v-list-tile
						class="akce"	v-for="akce in typyAkci" :key="akce.key">
						<v-list-tile-content>
							<v-list-tile-title>{{ akce.title }}</v-list-tile-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-btn
									class="ma-0"
									color="primary"
									@click="next(akce.key_in_list)"
							>Vybrat
							</v-btn>
						</v-list-tile-action>
					</v-list-tile>
					<v-layout row wrap fill-height align-center justify-space-between>
						<v-btn
								class="ma-0"
								color="primary"
								@click="back"
						>Zpět
						</v-btn>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
    import {init} from '@/api/api'

    export default {
      name: "FastSelect-1",
      computed: {
            sluzby() {
                return this.$store.state.services.filter(item => item.nid != 4 && item.nid != 281 && item.nid != 1982)
            },
            typyAkci: function() {
                return this.$store.state.serviceTypes;
            }
        },
        methods: {
            back() {
                this.$router.push({name: 'Step1'});
            },
            next(akceId) {
                this.$router.push({name: 'FastSelect2', params: {actionType: akceId}});
            },
            callInitRequest() {
                init(-1).then(response => {
                    this.$store.commit('resetServices');
                    this.$store.commit('setActionsList', response.data.data.actions);
                    this.$store.commit('setPobockyOptions', response.data.data.pobocky_options);
                });
            },
        },
        mounted() {
            this.callInitRequest();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FastSelect1.vue